export default {
  seller_post: "سرویس حمل‌ونقل پست",
  seller: "فروشنده",
};
